import React from 'react';
import './CustomAlert.css';

type CustomAlertProps = {
  message: string;
};

const CustomAlert: React.FC<CustomAlertProps> = ({ message }) => {
  /**
   * Simple div with message text
   * STRUCTURE:
   * - Outer div: custom-alert class for toast styling
   * - Inner p: Message text
   * STYLING:
   * CSS handles:
   * - Position (typically fixed at top or bottom)
   * - Fade in/out animations
   * - Background color and text styling
   * - Shadow and border radius
   */
  return (
      <div className="custom-alert">
        <p>{message}</p>
      </div>
  );
};

export default CustomAlert;

